export default {'MA': {'public': 2666667,
  'private': 5789855,
  'number': 39,
  'rel': 191.8162,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'IN': {'public': 30277754,
  'private': 16243164,
  'number': 80,
  'rel': 625.7374,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'ID': {'public': 29433333,
  'private': 8296982,
  'number': 69,
  'rel': 368.404,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'TR': {'public': 26146289,
  'private': 2779271,
  'number': 49,
  'rel': 191.873,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'BD': {'public': 24223093,
  'private': 7572850,
  'number': 61,
  'rel': 257.4191,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'VN': {'public': 22998027,
  'private': 12665097,
  'number': 51,
  'rel': 227.0506,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'MX': {'public': 20233333,
  'private': 5094079,
  'number': 51,
  'rel': 209.0082,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'MZ': {'public': 18265594,
  'private': 5337418,
  'number': 13,
  'rel': 98.6407,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BR': {'public': 12586929,
  'private': 5777339,
  'number': 68,
  'rel': 261.0477,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'PH': {'public': 11864931,
  'private': 5154581,
  'number': 53,
  'rel': 226.4287,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'MR': {'public': 10966667,
  'private': 1698402,
  'number': 3,
  'rel': 48.0223,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'FJ': {'public': 8592358,
  'private': 1549660,
  'number': 4,
  'rel': 22.5361,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'YE': {'public': 8300000,
  'private': 2543758,
  'number': 10,
  'rel': 50.649,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'GH': {'public': 7836000,
  'private': 5249177,
  'number': 36,
  'rel': 388.9975,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'KE': {'public': 7234232,
  'private': 10543534,
  'number': 61,
  'rel': 491.5374,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TZ': {'public': 6790258,
  'private': 7312048,
  'number': 38,
  'rel': 283.169,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BZ': {'public': 6310281,
  'private': 2535838,
  'number': 4,
  'rel': 16.4693,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'CV': {'public': 6132114,
  'private': 1531265,
  'number': 5,
  'rel': 38.8593,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TN': {'public': 5666667,
  'private': 5112269,
  'number': 33,
  'rel': 167.8379,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'CN': {'public': 5400000,
  'number': 44,
  'rel': 242.3256,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'SB': {'public': 4980114,
  'private': 2000746,
  'number': 2,
  'rel': 11.126,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'PE': {'public': 4754640,
  'private': 5174460,
  'number': 43,
  'rel': 130.0336,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'MG': {'public': 4657556,
  'private': 3553298,
  'number': 15,
  'rel': 80.3151,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'CL': {'public': 4617798,
  'number': 18,
  'rel': 59.4405,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'AO': {'public': 4566667,
  'private': 3780472,
  'number': 10,
  'rel': 97.4851,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'HT': {'public': 4498333,
  'private': 4958002,
  'number': 9,
  'rel': 34.9987,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'SN': {'public': 4354950,
  'private': 4225124,
  'number': 12,
  'rel': 110.2821,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TG': {'public': 4281430,
  'private': 2897045,
  'number': 6,
  'rel': 65.4225,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'PG': {'public': 4070132,
  'private': 1985399,
  'number': 6,
  'rel': 19.2469,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'GY': {'public': 3904783,
  'private': 2869623,
  'number': 4,
  'rel': 15.0889,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'MM': {'public': 3764710,
  'private': 4583510,
  'number': 32,
  'rel': 124.7975,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'HN': {'public': 3609028,
  'private': 3537614,
  'number': 4,
  'rel': 32.4671,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'TV': {'public': 3233333,
  'private': 848301,
  'number': 1,
  'rel': 10.767,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'TH': {'public': 3135042,
  'private': 6844289,
  'number': 52,
  'rel': 191.1851,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'TL': {'public': 3101667,
  'private': 2183656,
  'number': 4,
  'rel': 26.5502,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'KI': {'public': 2751500,
  'private': 1082178,
  'number': 1,
  'rel': 10.9019,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'FM': {'public': 2746442,
  'private': 981445,
  'number': 1,
  'rel': 10.6703,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'GT': {'public': 2744250,
  'private': 4628812,
  'number': 8,
  'rel': 49.2672,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'GM': {'public': 2633333,
  'private': 2082901,
  'number': 3,
  'rel': 45.0832,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'VU': {'public': 2394454,
  'private': 1471945,
  'number': 2,
  'rel': 12.0219,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'SO': {'public': 2267923,
  'private': 2118466,
  'number': 8,
  'rel': 92.9631,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'CI': {'public': 2183170,
  'private': 1804824,
  'number': 11,
  'rel': 116.3364,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'MY': {'public': 2169329,
  'private': 3128108,
  'number': 57,
  'rel': 247.4625,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'GW': {'public': 2119042,
  'private': 2025675,
  'number': 3,
  'rel': 35.2631,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'KH': {'public': 2059478,
  'private': 5033183,
  'number': 33,
  'rel': 157.6894,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'CU': {'public': 2018583,
  'private': 2267971,
  'number': 1,
  'rel': 19.1104,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'SV': {'public': 2008995,
  'private': 3237567,
  'number': 3,
  'rel': 27.1946,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'MV': {'public': 1988333,
  'private': 1745675,
  'number': 4,
  'rel': 29.4488,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'LR': {'public': 1951319,
  'private': 4001617,
  'number': 4,
  'rel': 65.4041,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'LC': {'public': 1867491,
  'private': 1476844,
  'number': 2,
  'rel': 10.4159,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'GD': {'public': 1846164,
  'private': 1766203,
  'number': 2,
  'rel': 10.55,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'KM': {'public': 1765594,
  'private': 1471001,
  'number': 3,
  'rel': 43.0335,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'CO': {'public': 1756521,
  'private': 6804840,
  'number': 47,
  'rel': 145.1098,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'CD': {'public': 1708333,
  'private': 4035631,
  'number': 17,
  'rel': 95.3438,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'DZ': {'public': 1700000,
  'private': 1156740,
  'number': 29,
  'rel': 143.9638,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'AG': {'public': 1689300,
  'number': 2,
  'rel': 8.5166,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'DJ': {'public': 1675935,
  'private': 1966939,
  'number': 4,
  'rel': 46.5829,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BF': {'public': 1645563,
  'private': 3864606,
  'number': 7,
  'rel': 62.3809,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'NE': {'public': 1633333,
  'private': 3658145,
  'number': 6,
  'rel': 61.6746,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'MH': {'public': 1568180,
  'private': 928620,
  'number': 1,
  'rel': 10.0,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'NA': {'public': 1466667,
  'private': 4290965,
  'number': 3,
  'rel': 31.0,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'SD': {'public': 1433333,
  'private': 3933149,
  'number': 15,
  'rel': 107.9369,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'ST': {'public': 1372649,
  'private': 2043383,
  'number': 4,
  'rel': 34.1475,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'LK': {'public': 1363331,
  'private': 3485867,
  'number': 21,
  'rel': 67.4146,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'WS': {'public': 1350821,
  'private': 1708077,
  'number': 1,
  'rel': 13.3502,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'MU': {'public': 1316989,
  'private': 3026996,
  'number': 10,
  'rel': 86.947,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'ZA': {'public': 1249003,
  'private': 13884625,
  'number': 68,
  'rel': 363.0379,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'GN': {'public': 1245460,
  'private': 3622596,
  'number': 7,
  'rel': 65.9533,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TO': {'public': 1162591,
  'private': 2145376,
  'number': 2,
  'rel': 10.7136,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'EC': {'public': 1055518,
  'private': 3250865,
  'number': 11,
  'rel': 53.4527,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'BJ': {'public': 982130,
  'private': 2957758,
  'number': 10,
  'rel': 92.6078,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BS': {'public': 965917,
  'number': 4,
  'rel': 8.523,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'DO': {'public': 944850,
  'private': 4217091,
  'number': 6,
  'rel': 28.5554,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'AR': {'public': 942450,
  'private': 3949975,
  'number': 29,
  'rel': 110.8284,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'PK': {'public': 870766,
  'private': 3867352,
  'number': 68,
  'rel': 283.6845,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'LB': {'public': 851813,
  'private': 8560852,
  'number': 16,
  'rel': 83.4184,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'CR': {'public': 781617,
  'private': 3537632,
  'number': 12,
  'rel': 36.697,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'AL': {'public': 777990,
  'private': 2950733,
  'number': 9,
  'rel': 31.9766,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'NR': {'public': 668790,
  'number': 1,
  'rel': 7.0,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'UY': {'public': 658725,
  'number': 3,
  'rel': 32.7806,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'JM': {'public': 655161,
  'private': 4200104,
  'number': 5,
  'rel': 23.6442,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'PS': {'public': 642263,
  'private': 831726,
  'number': 9,
  'rel': 43.7983,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'NI': {'public': 600128,
  'private': 3475149,
  'number': 4,
  'rel': 39.0555,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'CG': {'public': 587498,
  'private': 5862631,
  'number': 7,
  'rel': 52.8651,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'EG': {'public': 583617,
  'private': 6249387,
  'number': 62,
  'rel': 287.9446,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'PR': {'public': 580170,
  'number': 8,
  'rel': 25.7737,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'PA': {'public': 552716,
  'private': 3504095,
  'number': 2,
  'rel': 24.9702,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'UA': {'public': 490414,
  'private': 2639879,
  'number': 12,
  'rel': 88.9066,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'MD': {'public': 433700,
  'private': 1933484,
  'number': 2,
  'rel': 12.9763,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'DM': {'public': 416803,
  'private': 4518473,
  'number': 2,
  'rel': 13.0102,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'ML': {'public': 400417,
  'private': 5350619,
  'number': 9,
  'rel': 75.5147,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'ZW': {'public': 368333,
  'private': 3211981,
  'number': 24,
  'rel': 130.195,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'NP': {'public': 295041,
  'private': 4639656,
  'number': 44,
  'rel': 143.7678,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'GA': {'public': 277620,
  'private': 3579103,
  'number': 7,
  'rel': 47.9793,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'SL': {'public': 253637,
  'private': 4503078,
  'number': 8,
  'rel': 52.0437,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'ME': {'public': 240141,
  'private': 831371,
  'number': 1,
  'rel': 12.2883,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'VE': {'public': 199119,
  'private': 2293012,
  'number': 7,
  'rel': 48.5652,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'RU': {'public': 188013,
  'number': 18,
  'rel': 118.4547,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'AZ': {'public': 172200,
  'private': 2559179,
  'number': 4,
  'rel': 27.2022,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'KP': {'public': 166667,
  'private': 351251,
  'number': 1,
  'rel': 7.8055,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'VC': {'public': 155906,
  'private': 1612316,
  'number': 2,
  'rel': 10.4046,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'BO': {'public': 129924,
  'private': 3160640,
  'number': 9,
  'rel': 38.0526,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'PY': {'public': 127951,
  'private': 2875100,
  'number': 5,
  'rel': 37.768,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'SR': {'public': 121532,
  'private': 2318358,
  'number': 4,
  'rel': 17.079,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'NG': {'public': 114487,
  'private': 3710779,
  'number': 59,
  'rel': 429.8619,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'UG': {'public': 105333,
  'private': 6483109,
  'number': 41,
  'rel': 269.4399,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BA': {'public': 81856,
  'private': 2406723,
  'number': 5,
  'rel': 18.0373,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'CM': {'public': 74578,
  'private': 3674044,
  'number': 20,
  'rel': 90.4657,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'GQ': {'public': 73857,
  'number': 4,
  'rel': 29.8906,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'RO': {'public': 64922,
  'private': 2747455,
  'number': 20,
  'rel': 87.734,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'VI': {'public': 64861,
  'number': 1,
  'rel': 4.1911,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'SZ': {'public': 39492,
  'private': 1812644,
  'number': 4,
  'rel': 53.3957,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'IR': {'public': 38214,
  'private': 1842231,
  'number': 13,
  'rel': 38.8967,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'RS': {'public': 19653,
  'private': 2436607,
  'number': 6,
  'rel': 35.8355,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'BI': {'public': 19176,
  'private': 2958151,
  'number': 5,
  'rel': 65.4945,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BB': {'public': 10333,
  'number': 4,
  'rel': 8.9292,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'IQ': {'public': 10306,
  'private': 5000517,
  'number': 28,
  'rel': 99.9544,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'RW': {'public': 10000,
  'private': 4823306,
  'number': 20,
  'rel': 126.2915,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'GE': {'public': 7395,
  'private': 4587779,
  'number': 13,
  'rel': 42.0589,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'ER': {'public': 4088,
  'private': 1599502,
  'number': 3,
  'rel': 42.525,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'JO': {'public': 3869,
  'private': 5595567,
  'number': 22,
  'rel': 105.9813,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'ET': {'public': 3429,
  'private': 4648179,
  'number': 32,
  'rel': 156.687,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'BG': {'public': 1699,
  'private': 2167549,
  'number': 8,
  'rel': 33.4159,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'KG': {'public': 1667,
  'private': 2494090,
  'number': 6,
  'rel': 22.4542,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'ZM': {'public': 1667,
  'private': 4525474,
  'number': 20,
  'rel': 155.3776,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TJ': {'public': 1331,
  'private': 2499563,
  'number': 4,
  'rel': 13.5172,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'KZ': {'public': 667,
  'private': 2353258,
  'number': 2,
  'rel': 18.7491,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'LA': {'public': 139,
  'private': 1423251,
  'number': 10,
  'rel': 29.0789,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'AF': {'public': 0,
  'private': 4500066,
  'number': 23,
  'rel': 95.4762,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'AM': {'public': 0,
  'private': 3056461,
  'number': 2,
  'rel': 28.2789,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'BY': {'public': 0,
  'private': 1546257,
  'number': 1,
  'rel': 17.9527,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'BT': {'public': 0,
  'private': 1819539,
  'number': 6,
  'rel': 20.5304,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'BW': {'public': 0,
  'private': 2760818,
  'number': 16,
  'rel': 98.48,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'VG': {'public': 0,
  'number': 2,
  'rel': 3.2215,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'KY': {'public': 0,
  'number': 5,
  'rel': 9.2539,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'CF': {'public': 0,
  'private': 1886258,
  'number': 5,
  'rel': 36.012,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'TD': {'public': 0,
  'private': 1865510,
  'number': 5,
  'rel': 39.6057,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'XK': {'public': 0,
  'private': 2024090,
  'number': 5,
  'rel': 33.4434,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'LS': {'public': 0,
  'private': 2225683,
  'number': 5,
  'rel': 56.4424,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'LY': {'public': 0,
  'private': 1531970,
  'number': 12,
  'rel': 64.6288,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'MW': {'public': 0,
  'private': 4266260,
  'number': 13,
  'rel': 98.6677,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'MN': {'public': 0,
  'private': 3586610,
  'number': 9,
  'rel': 28.6501,
  'region': 'Asia and the Pacific',
  'regionPublic': 295419563,
  'regionPrivate': 109070486},
 'MK': {'public': 0,
  'private': 2031007,
  'number': 3,
  'rel': 22.346,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'SS': {'public': 0,
  'private': 2427240,
  'number': 9,
  'rel': 79.5002,
  'region': 'Africa',
  'regionPublic': 302805926,
  'regionPrivate': 180682027},
 'KN': {'public': 0,
  'number': 2,
  'rel': 4.4771,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'SY': {'public': 0,
  'private': 4226259,
  'number': 7,
  'rel': 42.9807,
  'region': 'Western Asia',
  'regionPublic': 16401045,
  'regionPrivate': 19988662},
 'TT': {'public': 0,
  'number': 5,
  'rel': 15.2934,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'TM': {'public': 0,
  'private': 1591895,
  'number': 1,
  'rel': 16.5715,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'TC': {'public': 0,
  'number': 2,
  'rel': 4.9277,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'UZ': {'public': 0,
  'private': 2005889,
  'number': 5,
  'rel': 13.8819,
  'region': 'Europe',
  'regionPublic': 47870726,
  'regionPrivate': 45611531},
 'SC': {'private': 4055905, 'number': 3, 'rel': 40.4846},
 'HU': {'private': 2873253, 'number': 8, 'rel': 31.2227},
 'AS': {'private': 1816052, 'rel': 9.7767},
 'PW': {'private': 1053716, 'number': 1, 'rel': 10.4131},
 'LV': {'number': 2, 'rel': 7.4062},
 'GS': {'number': 1, 'rel': 1.0},
 'TW': {'number': 21, 'rel': 85.7556},
 'FR': {'number': 69, 'rel': 349.4309},
 'AW': {'number': 2,
  'rel': 5.0361,
  'region': 'Latin America and the Caribbean',
  'regionPublic': 139475733,
  'regionPrivate': 90748990},
 'CA': {'number': 65, 'rel': 312.212},
 'HK': {'number': 18, 'rel': 82.5936},
 'VA': {'number': 1, 'rel': 1.0},
 'NC': {'number': 1, 'rel': 3.683},
 'IT': {'number': 67, 'rel': 265.7956},
 'NZ': {'number': 30, 'rel': 67.4704},
 'AT': {'number': 18, 'rel': 54.1584},
 'IM': {'number': 1, 'rel': 2.9674},
 'BM': {'number': 1, 'rel': 9.4192},
 'IE': {'number': 15, 'rel': 66.7322},
 'GP': {'number': 2, 'rel': 9.68},
 'GF': {'number': 2, 'rel': 4.1273},
 'WF': {'number': 1, 'rel': 1.0},
 'SM': {'number': 1, 'rel': 2.0},
 'NU': {'number': 1, 'rel': 3.0},
 'SE': {'number': 34, 'rel': 106.7112},
 'SK': {'number': 3, 'rel': 10.3182},
 'MQ': {'number': 2, 'rel': 7.3362},
 'GU': {'number': 1, 'rel': 4.1003},
 'YT': {'number': 1, 'rel': 4.533},
 'NO': {'number': 12, 'rel': 42.7859},
 'EE': {'number': 1, 'rel': 9.3666},
 'BE': {'number': 52, 'rel': 170.0399},
 '': {'number': 1},
 'CY': {'number': 10, 'rel': 36.491},
 'AU': {'number': 66, 'rel': 257.5892},
 'MS': {'number': 2, 'rel': 2.8917},
 'DK': {'number': 22, 'rel': 50.1243},
 'KR': {'number': 29, 'rel': 100.4443},
 'TK': {'number': 1, 'rel': 4.5507},
 'IL': {'number': 23, 'rel': 90.3804},
 'BN': {'number': 5, 'rel': 22.6217},
 'NL': {'number': 54, 'rel': 182.1387},
 'BV': {'number': 1, 'rel': 1.0},
 'CZ': {'number': 3, 'rel': 21.1992},
 'AI': {'number': 1, 'rel': 2.0},
 'RE': {'number': 4, 'rel': 9.1923},
 'SG': {'number': 37, 'rel': 183.2545},
 'DE': {'number': 75, 'rel': 319.5985},
 'MT': {'number': 2, 'rel': 11.3261},
 'JP': {'number': 37, 'rel': 137.0835},
 'TF': {'number': 1, 'rel': 1.0},
 'FI': {'number': 12, 'rel': 31.5735},
 'SH': {'number': 1, 'rel': 1.0},
 'SA': {'number': 52, 'rel': 212.7975},
 'FK': {'number': 1, 'rel': 2.0},
 'PM': {'number': 1, 'rel': 1.0},
 'GG': {'number': 1, 'rel': 5.6006},
 'TA': {'number': 1, 'rel': 1.0},
 'PF': {'number': 2, 'rel': 5.7596},
 'CH': {'number': 33, 'rel': 127.7781},
 'KW': {'number': 13, 'rel': 86.0942},
 'GB': {'number': 76, 'rel': 457.4843},
 'LU': {'number': 1, 'rel': 17.5439},
 'PT': {'number': 36, 'rel': 117.299},
 'CX': {'number': 1, 'rel': 1.0},
 'AE': {'number': 57, 'rel': 243.6869},
 'LI': {'number': 1, 'rel': 3.9582},
 'AN': {'number': 1, 'rel': 1.0},
 'HR': {'number': 3, 'rel': 17.7184},
 'FO': {'number': 1, 'rel': 3.1366},
 'OM': {'number': 18, 'rel': 77.5331},
 'QA': {'number': 28, 'rel': 128.165},
 'LT': {'number': 4, 'rel': 11.7736},
 'PL': {'number': 17, 'rel': 69.9623},
 'GI': {'number': 1, 'rel': 2.2597},
 'BH': {'number': 12, 'rel': 68.1892},
 'PN': {'number': 1, 'rel': 1.0},
 'US': {'number': 81, 'rel': 868.8956},
 'GR': {'number': 23, 'rel': 73.7063},
 'ES': {'number': 54, 'rel': 204.1386},
 'GL': {'number': 1, 'rel': 2.0798},
 'IS': {'number': 2, 'rel': 8.226},
 'NF': {'number': 1, 'rel': 1.0},
 'IO': {'number': 1, 'rel': 1.0},
 'SI': {'number': 2, 'rel': 12.4025},
 'MO': {'number': 4, 'rel': 13.3567},
 'AD': {'rel': 1.4395},
 'MC': {'rel': 2.149},
 'CK': {'rel': 1.5179},
 'JE': {'rel': 4.2344}}



// WEBPACK FOOTER //
// ./src/assets/fundingData.js